import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { NotificationsSidebarStatus } from '@enums/notifications';
import { NotificationsService } from '@services/notifications';
import { AuthService } from '@services/auth/auth.service';
import { HeaderComponent } from '../header/header.component';
import { SidenavComponent } from '../sidenav/sidenav.component';
import { RouterOutlet } from '@angular/router';
import { NotificationsSidenavComponent } from '../../../../components/notifications-sidenav/notifications-sidenav.component';
import { ObPomiarService } from '../../../../modules/cms/overbalance/ob-pomiar.service';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'app-cms-layout',
	templateUrl: './cms-layout.component.html',
	styleUrls: ['./cms-layout.component.less'],
	standalone: true,
	imports: [HeaderComponent, SidenavComponent, RouterOutlet, NotificationsSidenavComponent],
})
export class CmsLayoutComponent {
	private readonly _ns = inject(NotificationsService);

	constructor() {
		// Pomiar Overbalance na żywo trwa w całym panelu, nie tylko na stronie modułu.
		inject(ObPomiarService);
		// Panel renderuje się tylko po zalogowaniu → odświeżamy profil, żeby lista modułów
		// (odblokowania od admina, a później za tokeny) nie czekała na ponowne logowanie.
		inject(AuthService)
			.getMe()
			.subscribe({ error: () => undefined });
	}

	mobileMenuActive = false;
	sidenavCollapsed = signal(false);

	toggleMobileMenu(): void {
		this.mobileMenuActive = !this.mobileMenuActive;
		this._ns.notificationsSidebarStatus.set(NotificationsSidebarStatus.Close);
	}

	onMenuClose(): void {
		this.mobileMenuActive = false;
	}

	toggleCollapse(): void {
		this.sidenavCollapsed.update((v) => !v);
	}
}
